module.exports = __webpack_public_path__ + "static/media/relatorios.997768a8.png";